import React from "react";
export function YearTrack() {
  return <div className="mt-12 rounded-[14px] border border-navy/10 bg-ice p-5 sm:p-8 lg:mt-16" data-id="element-286" data-mp="1ly1v7si1ma5s">
      <h3 className="font-display text-[28px] font-bold uppercase leading-none text-navy" data-id="element-287" data-mp="1rs7lqhq5cwsq">
        12 lessons. <span className="text-navy underline decoration-cyan decoration-[4px] underline-offset-[6px]" data-id="element-288" data-mp="1d3kubhn8wel5">One clear progression.</span>
      </h3>
      <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-289" data-mp="143fw9y3xysjn">
        Teach in sequence and adapt the pace to your group and timetable.
      </p>
      <ol className="mt-6 grid grid-cols-3 gap-2 sm:grid-cols-4 lg:grid-cols-12" data-id="element-290" data-mp="193u69lp3sckb">
        {Array.from({
        length: 12
      }, (_, i) => <li key={i} className="relative overflow-hidden rounded-[8px] border border-navy/10 bg-navy px-3 pb-3 pt-4" data-id="element-291" data-mp="u7cu4s93atwp">
            <span className="absolute inset-x-0 top-0 h-1 bg-cyan" aria-hidden="true" data-id="element-292" data-mp="2oj9jmfnz1pp4" />
            <span className="block font-display text-[26px] font-extrabold leading-none text-cyan" data-id="element-293" data-mp="2ti4cybjkewnh">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.08em] text-ice/80" data-id="element-294" data-mp="1er2nsgv6x3tj">
              Lesson
            </span>
          </li>)}
      </ol>
    </div>;
}